import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=2b4bcab4&scoped=true"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"
import style0 from "./IssueDetail.vue?vue&type=style&index=0&id=2b4bcab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4bcab4",
  null
  
)

export default component.exports